/** 服务套餐API */
import type { Api } from '@/typings/api';
import { download, post } from '../../request';
const prefix = '/store/servicePackage';
/**
 * 分页查询服务套餐
 *
 * @param params 查询参数
 */
export const findPage: Api.CommonMethods.FindPage<Api.Store.ServicePackage> = params => {
  return post(`${prefix}/findPage`, params);
};
/**
 * 查询服务套餐列表
 *
 * @param params 查询参数
 */
export const findAll: Api.CommonMethods.FindAll<Api.Store.ServicePackage> = params => {
  return post(`${prefix}/findAll`, params);
};
/**
 * 查询单个服务套餐
 *
 * @param id 服务套餐ID
 * @param column 查询字段
 */
export const findOne: Api.CommonMethods.FindOne<Api.Store.ServicePackage> = (id: string, column?: string[]) => {
  return post(`${prefix}/findOne`, { id, column });
};
/**
 * 保存服务套餐
 *
 * @param params 服务套餐信息
 */
export const doSave: Api.CommonMethods.Save = params => {
  return post(`${prefix}/save`, params);
};
/**
 * 更新服务套餐信息
 *
 * @param params 服务套餐信息
 */
export const doUpdate: Api.CommonMethods.Update = params => {
  return post(`${prefix}/update`, params);
};
/**
 * 删除服务套餐
 *
 * @param id 服务套餐ID
 */
export const doDelete: Api.CommonMethods.Delete = id => {
  return post(`${prefix}/delete?id=${id}`);
};
/**
 * 批量删除服务套餐
 *
 * @param ids 服务套餐ID数组
 */
export const doBatchDelete: Api.CommonMethods.BatchDelete = ids => {
  return post(`${prefix}/deleteList`, { ids });
};

/**
 * 导出
 *
 * @param params
 * @returns
 */
export const doExport = (params: Api.Common.CommonSearchParams) => {
  return download(`${prefix}/export`, params);
};

export default {
  findPage,
  findOne,
  doSave,
  doUpdate,
  doDelete,
  doBatchDelete
};
